"use strict";
export const getActiveElement = (el) => {
  return el.getRootNode().activeElement;
};
//# sourceMappingURL=get-active-element.dev.js.map
